export function capitalize(value) {
	if (!value) return '';
	value = value.toString();
	const arr = value.split(' ');
	const capitalizedArray = [];
	arr.forEach((word) => {
		const capitalized = word.charAt(0).toUpperCase() + word.slice(1);
		capitalizedArray.push(capitalized);
	});
	return capitalizedArray.join(' ');
}

export function substr(value, limit = 50, prefix = '') {
	if (value.length > limit) {
		return value.substring(0, limit) + prefix;
	}

	return value;
}

export function registerFilters(app) {
	app.config.globalProperties.$filters = {
		capitalize,
		substr,
	};
}
